(() => {
	const trigger = document.querySelector(".about__videoTrigger");
	const modal = document.querySelector("#aboutVideoModal");
	if (!trigger || !modal) return;

	const frame = modal.querySelector("iframe");
	const closeButton = modal.querySelector(".aboutVideoModal__close");
	let videoId;
	try {
		const url = new URL(trigger.dataset.videoUrl);
		if (!["https:", "http:"].includes(url.protocol)) return;
		const host = url.hostname.replace(/^www\./, "");
		if (host === "youtu.be") {
			videoId = url.pathname.split("/")[1];
		} else if (["youtube.com", "m.youtube.com", "youtube-nocookie.com"].includes(host)) {
			videoId = url.pathname === "/watch"
				? url.searchParams.get("v")
				: url.pathname.match(/^\/(?:embed|shorts|live)\/([^/]+)/)?.[1];
		}
	} catch {
		return;
	}
	if (!/^[a-zA-Z0-9_-]{11}$/.test(videoId)) return;

	let previousOverflow;
	trigger.addEventListener("click", () => {
		previousOverflow = document.documentElement.style.overflow;
		document.documentElement.style.overflow = "hidden";
		modal.showModal();
		frame.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&playsinline=1`;
	});
	closeButton.addEventListener("click", () => modal.close());
	modal.addEventListener("click", (event) => {
		if (event.target !== modal) return;
		const bounds = modal.getBoundingClientRect();
		if (event.clientX < bounds.left || event.clientX > bounds.right
			|| event.clientY < bounds.top || event.clientY > bounds.bottom) {
			modal.close();
		}
	});
	modal.addEventListener("close", () => {
		frame.removeAttribute("src");
		document.documentElement.style.overflow = previousOverflow;
		trigger.focus({ preventScroll: true });
	});
})();
